import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getUnhandledReports = (
    token: string,
    backend: string,
) => {
    return fetch(
        `${getApiUrl(backend)}unhandled_reports`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getUnhandledReports;
